<checkbox [(ngModel)]="checked" single="true" (onChange)="onChange()">Checkbox</checkbox>